export default "__VITE_ASSET__C2tCjBS9__"